import { api } from './client'

// Cài đặt website bán lẻ (cms-plan api-contract §2): chữ quảng bá, link, SEO…
// của website / Mini App. Mỗi kind lưu riêng, có version chống ghi đè.

/** Các kind, đúng thứ tự tab trên màn quản trị. */
export const SHOP_SITE_SETTING_KINDS = [
    'brand',
    'header',
    'footer',
    'socials',
    'seo',
    'product_page',
    'checkout',
    'home_extra',
    'ocop',
    'miniapp',
] as const

export type ShopSiteSettingKind = (typeof SHOP_SITE_SETTING_KINDS)[number]

export interface ShopSiteSetting {
    kind: ShopSiteSettingKind
    version: number
    updated_at: string
    data: Record<string, unknown>
}

export interface ShopSiteSettingInput {
    version: number
    data: Record<string, unknown>
}

export const shopSiteSettingsApi = {
    list: () =>
        api.get<{ settings: ShopSiteSetting[] }>('/shop-admin/site-settings'),
    save: (kind: ShopSiteSettingKind, input: ShopSiteSettingInput) =>
        api.put<ShopSiteSetting>(`/shop-admin/site-settings/${kind}`, input),
}
